module.exports = true;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_library.js
 ** module id = 171
 ** module chunks = 0
 **/